export default function GeolookDashboard() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 120px)' }}>
      <div style={{ padding: '12px 20px', background: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
        <h2 style={{ margin: 0, fontSize: 16 }}>🔍 品牌管家 — GEO 诊断工具</h2>
      </div>
      <iframe
        src="https://api.boxiaotu.cn/geolook/"
        style={{ flex: 1, border: 'none', width: '100%' }}
        title="品牌管家"
      />
    </div>
  );
}
